// @flow
import { createResource, type Resource } from '@gandi/redux-resource';
import type { ResourceThunkAction } from '../../types';

export const resource: Resource<> = createResource('truspilot');

type FetchUrlTrustpilotAction<R> = (token: string) => R;

export const fetchUrlTrustpilot: FetchUrlTrustpilotAction<
  ResourceThunkAction
> = token => resource.fetchOne(`/newsletter-anonymous/trustpilot-bgl/${token}`);
